const colors = {
  dustyGray: `#999`,
};

export default colors;
